import React, { Component } from 'react';
import { connect } from 'react-redux';
import LANGUAGES_CONTROLLER from '../../controllers/languages'
import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import Logger, {LOG_LEVELS} from '../../utils/logger';
import { SSelect } from '@avalara/skylab-sdk/react';
import ReadOnlyWrapper from '../authorization/ReadOnlyWrapper';

const log = new Logger('MAPPED_ACCOUNT_SETTING_FIELD', LOG_LEVELS.ERROR);

class MappedAccountSettingField extends Component {

  render() {
    log.debug('render(): ', this.props);
    // TODO: At some point we should do something with the mapping.type and mapping.values
    
    return (
      <ReadOnlyWrapper>
        <div>
          <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, this.props.mapping.languageString)}
          </label>
          {/* TODO: at some point we should do something with the mapping.type and mapping.values*/}
          {(() => {
            switch (this.props.mapping.type) {
              case 'text':
              case 'number':
              case 'email':
              case 'date':
                return (<input
                  type={this.props.mapping.type}
                  onChange={this.props.onFieldChange}
                  value={this.props.value}
                />);
              case 'textarea':
                return (<textarea 
                  rows="5" 
                  cols="20" 
                  onChange={this.props.onFieldChange}
                  value={this.props.value}
                />);
              case 'select':
                  log.debug('render(): select', this.props.value);
                // SSelect matches options against string DOM values, so option values must be strings
                const optionsList = this.props.mapping.values.map((option, index) => ({
                  key: String(option.value),
                  value: String(option.value),
                  label: LANGUAGES_CONTROLLER.format(this.props.languages, option.displayString),
                  selected: String(this.props.value) === String(option.value)
                }));
                
                return (<SSelect
                  inputId={`select-${this.props.mapping.id}`}
                  optionsList={optionsList}
                  multiple={false}
                  onS-select={(e) => {
                    const syntheticEvent = {
                      target: { value: e.detail.item.value }
                    };
                    this.props.onFieldChange(syntheticEvent);
                  }}
                />);
              default:
                return (<input
                  type="text"
                  onChange={this.props.onFieldChange}
                  value={this.props.value}
                />);
            }
          })()}
          {
            this.props.mapping.helpText ? (<div id={`hint_${this.props.mapping.id}`} class="help-text">{this.props.mapping.helpText}</div>): (<span></span>)
          }
          {
            this.props.mapping.id === 'LedgerBasedUponDate' && (
              <s-alert status="info" class="mt10 text-sm" data-testid="ledger-setting-country-info" nodismiss={true}>
                <span class="text-sm"><LanguageStringResolver string="ledger_setting_country_info" /></span>
              </s-alert>
            )
          }
        </div>
      </ReadOnlyWrapper>
    )
  }
}

// Which props do we want to inject, given the global state?
function mapStateToProps(state) {

  return {
    languages: state.languages
  };
}


// Wrap the component to inject dispatch and state into it
export default connect(mapStateToProps)(MappedAccountSettingField);
